import React from 'react';
import Overview from './components/Overview';
import Leadership from './components/Leadership';
import StrategicObjectives from './components/StrategicObjectives';
import '../About/styles/About.css';

const AboutUs = () => {
  return (
    <div className="about-us" id='about-us'>
      <div className="page-header">
        <div className="header-gradient">
          <h1>About Our Department</h1>
          <p className="page-subtitle">Strengthening South Sudan's Health Security Through One Health Approach</p>
        </div>
      </div>
      
      <div className="content-container">
        <Overview/>
        <Leadership/>
        <StrategicObjectives />
      </div>
    </div>
  );
};

export default AboutUs;